import React, { useEffect, useRef, useCallback, useState } from 'react';
import 'autocompleter/autocomplete.css';

const LocationSearch = ({onLocationChange, unfocus, onlyLocations}) => {
    const inputRef = useRef(null);

    const getLocationType = (item) =>{
        if (item.county && item.municipality) return 'location';
        if (item.municipality) return 'municipality';
        if (item.county) return 'county';
        return 'location';
    };
    
    const getLocationLabel = (item) => {
        if (item.county && item.municipality) return `${item.name} (Ort)`;
        if (item.municipality) return `${item.municipality.name} (Kommun)`;
        if (item.county) return `${item.county.name} (Region)`;
        return item.name;
    };

    // Extract this to component
    const search = async (query) => {
        if (!query || query.length < 2) return [];
        
        try {
            const response = await fetch(`/api/locations/search?query=${encodeURIComponent(query)}${onlyLocations ? '&onlyLocations=true' : ''}`);
            const results = await response.json();
            
            return results.map(item => ({
                ...item,
                type: getLocationType(item),
                label: getLocationLabel(item)
            }));
        } catch (error) {
            console.error('Failed to fetch locations:', error);
            return [];
        }
    };

    const closeDropdown = () => {
        if (inputRef.current) {
            inputRef.current.value = '';
        }
    }
    
    useEffect(() => {
            if (!inputRef.current) return;
    
            inputRef.current.focus();
    
            const autocomplete = window.autocomplete({
                input: inputRef.current,
                fetch: async (text, update) => {
                    const results = await search(text);
                    update(results);
                },
                render: (item) => {
                    const div = document.createElement('div');
                    div.classList.add('location-item');
                    const icon = document.createElement('i');
                    icon.className = 'fa-solid fa-location-pin';
                    div.appendChild(icon);
                    div.appendChild(document.createTextNode(' ' + item.label));
                    return div;
                },
                onSelect: (item) => {
                    const selected = {
                        type: item.type,
                        id: item.id,
                        name: item.label,
                        location: item
                    };
                    closeDropdown();
                    unfocus && unfocus();
                    onLocationChange(selected);
                },
                minLength: 2,
                debounceWaitMs: 300,
                preventSubmit: true
            });
    
            return () => {
                // Cleanup if needed
            };
        }, []);


    return <div className="location-search">
        <i className="fa-solid fa-magnifying-glass"></i>
        <input
            ref={inputRef}
            type="text"
            placeholder="Sök ort, kommun eller region"
        />
    </div>;
}

export default LocationSearch;